import type { DraftInput } from '../../../../shared/drafts';

function createQuestion(level: number): DraftInput['questions'][number] {
  return {
    prompt: `${level}. yarışma sorusu`, wagonStyle: 'wide', levels: [level], timeLimitSeconds: null,
    choices: [
      { text: 'Doğru cevap', isCorrect: true },
      { text: 'Yanlış cevap 1', isCorrect: false },
      { text: 'Yanlış cevap 2', isCorrect: false },
      { text: 'Yanlış cevap 3', isCorrect: false },
    ],
  };
}

export function createBillionaireQuizDraft(): DraftInput {
  return {
    title: 'Yeni Kim Milyarder Olmak İster?', templateKey: 'billionaire-quiz', levelMode: 'manual',
    maxLevels: 5, trackTime: true, timingMode: 'none',
    questions: Array.from({ length: 5 }, (_, index) => createQuestion(index + 1)),
  };
}

export function resizeBillionaireQuizDraft(draft: DraftInput, maxLevels: number): DraftInput {
  const safeLevels = Math.max(5, Math.min(20, Math.trunc(maxLevels)));
  return {
    ...draft, templateKey: 'billionaire-quiz', levelMode: 'manual', maxLevels: safeLevels,
    trackTime: true, bridgeMode: undefined, timingMode: 'none',
    questions: Array.from({ length: safeLevels }, (_, index) => {
      const level = index + 1;
      const existing = draft.questions.find((question) => question.levels[0] === level);
      return { ...(existing ?? createQuestion(level)), levels: [level], timeLimitSeconds: null };
    }),
  };
}
